import React, {useEffect, useState} from "react";
import {VsiBubble, VsiH4} from "../../../styled/App.styled";
import {useDataWithRoute, useTitleFromComponent} from "../../../utils/hooks";
import Grid from "../../../components/Grid";
import {Card, Spinner} from "reactstrap";
import {useVsiAppContext} from "../../../stores/VsiApp";
import VerticalBarChart from "../../../components/VerticalBarChart";
import { databaseMissingIndexesDefs } from "../../../utils/gridColumnDefs/databases/databaseIndexesDefs";

export default function DatabaseMissingIndexes({title}) {
    useTitleFromComponent(title);

    const { theme, client, periodId } = useVsiAppContext();
    const [data, {isLoading}] = useDataWithRoute(`/api/v6/report/database_missing_indexes_proc?client_id=${client.clientId}&period_id=${periodId}`);
    const [chartData, setChartData] = useState([]);
    const [chartCategories, setChartCategories] = useState([]);
    const [gridData, setGridData] = useState([]);

    useEffect(() => {
        setGridData(data?.recordset || []);

        setChartCategories(
            data?.recordsets?.[1]?.map(m => m.table_name)
        );

        setChartData([
            {
                name: "count",
                data: data?.recordsets?.[1]?.map(m => m.num_indexes)
            }
        ]);

    }, [data, isLoading]);


    return (
        <Card className={`report-card p-2 nav-card-${theme}`}>
            <VsiH4>Databases Missing Indexes</VsiH4>
            {isLoading ? <Spinner color={"primary"}/> : (
                <div>
                    <VsiBubble autobotName='ColumnChart'>
                        <VerticalBarChart
                            categories={chartCategories}
                            series={chartData}
                            changeAxisTitle={true}
                            yTitle1={"# of Indexes Needed"}
                            height={500}
                            axisMaxMin={{axis1Min: 0}}
                        />
                    </VsiBubble>
                    <VsiBubble>
                        <Grid addStyle
                              data={gridData}
                              isLoading={isLoading}
                              columnDefs={databaseMissingIndexesDefs}
                        />
                    </VsiBubble>
                </div>
            )}
        </Card>
    );
}
